import { axiosClient } from '../../clients/axios-client'
import type { FileExclusionResponseDto } from './dtos/file'
import { FileExclusionResponseDtoSchema } from './dtos/file'

export interface FileExclusionResult {
  fileId: string
  isExcluded: boolean
}

export async function setFileExclusion(
  fileId: string,
  isExcluded: boolean
): Promise<FileExclusionResult> {
  try {
    const { data } = await axiosClient.patch<FileExclusionResponseDto>(
      `/filepool/files/${fileId}/exclusion`,
      { is_excluded: isExcluded }
    )

    const { file_id, is_excluded } = FileExclusionResponseDtoSchema.parse(data)

    return {
      fileId: file_id,
      isExcluded: is_excluded,
    }
  } catch (error) {
    console.error(`Setting file exclusion failed. File id: ${fileId}`, error)
    throw error
  }
}
